module.exports = __webpack_public_path__ + "static/media/appstore.52f73669.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/appstore.png
// module id = 851
// module chunks = 0